import { ColorFunctions as Colors } from '@bubble-ui/particle-colors';
/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var getBackgroundColor = _ref => {
  var {
    autofill,
    designVersion,
    disabled,
    error,
    focused,
    hovered,
    warning
  } = _ref;
  return focused ? Colors.__backgroundInverse(designVersion) : autofill ? Colors.__backgroundAccentInline(designVersion) : disabled ? Colors.__backgroundDisabledWithBorder(designVersion) : error ? hovered ? Colors.__backgroundErrorWithBorderHovered(designVersion) : Colors.__backgroundErrorWithBorder(designVersion) : warning ? hovered ? Colors.__backgroundWarningWithBorderHovered(designVersion) : Colors.__backgroundWarningWithBorder(designVersion) : Colors.__backgroundInverse(designVersion);
};

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var getBorderColor = _ref2 => {
  var {
    autofill,
    designVersion,
    disabled,
    error,
    focused,
    hovered,
    warning
  } = _ref2;
  return focused ? Colors.__borderDefault(designVersion) : autofill ? Colors.__borderAccent(designVersion) : disabled ? Colors.__borderDisabled(designVersion) : error ? hovered ? Colors.__borderErrorHovered(designVersion) : Colors.__borderError(designVersion) : warning ? hovered ? Colors.__borderWarningHovered(designVersion) : Colors.__borderWarning(designVersion) : hovered ? Colors.__borderNeutralHovered(designVersion) : Colors.__borderNeutral(designVersion);
};

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var getLabelTextColor = _ref3 => {
  var {
    designVersion,
    disabled,
    error,
    warning
  } = _ref3;
  return disabled ? Colors.__textDisabled(designVersion) : error ? Colors.__textError(designVersion) : warning ? Colors.__textWarning(designVersion) : Colors.__textNeutral(designVersion);
};

/**
 * @deprecated this function is outdated and will be removed with v6.0.0
 */
export var getInputTextColor = _ref4 => {
  var {
    designVersion,
    disabled
  } = _ref4;
  return disabled ? Colors.__textDisabled(designVersion).toString() : Colors.__textDefault(designVersion).toString();
};
//# sourceMappingURL=index.js.map